export default {"src":"/_next/static/media/Home.8a15b6b0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};